<template>
  <div class="form-search-date">
    <el-row>
      <div class="el-col w-340">
        <el-row>
          <div class="el-col">
            <label slot="label" class="el-form-item__label">
              {{ $t('staff.box_search_date.start_date') }}
            </label>
          </div>
          <el-col :span="24">
            <date-form
              @change-date="setStartDate"
              :date="form.start"
              :yearPlaceHolder="this.$t('year')"
              :listYear="listYear"
            >
            </date-form>
          </el-col>
        </el-row>
      </div>
      <div class="el-col range">
        <span>〜</span>
      </div>
      <div class="el-col w-340">
        <el-row>
          <el-col :span="24">
            <label slot="label" class="el-form-item__label">
              {{ $t('staff.box_search_date.end_date') }}
            </label>
          </el-col>
          <el-col :span="24">
            <date-form
              @change-date="setEndDate"
              :date="form.end"
              :yearPlaceHolder="this.$t('year')"
              :listYear="listYear"
            >
            </date-form>
          </el-col>
        </el-row>
      </div>
    </el-row>
    <el-button type="danger" class="btn-search mb-25"
        @click="search"
        @keyup.enter.native="search">
        {{ $t('btn_search') }}
    </el-button>
  </div>
</template>
<script>
import { MONTHS, YEARS, CURRENT_YEAR, CURRENT_MONTH, CURRENT_DAY, YEARS_START_FROM_2022 } from '../../constants'

export default {
  emits: ['getPointAndMoney'],

  data() {
    return {
      months: MONTHS,
      years: YEARS,
      form: {
        start: {
          year: CURRENT_YEAR,
          month: CURRENT_MONTH,
          day: '01'
        },
        end: {
          year: CURRENT_YEAR,
          month: CURRENT_MONTH,
          day: CURRENT_DAY
        }
      },
      listYear: YEARS_START_FROM_2022
    }
  },

  methods: {
    search() {
      const data = {
        period_start: this.$dayjs(new Date(this.form.start.year, this.form.start.month - 1, this.form.start.day))
                      .format('YYYY-MM-DD'),
        period_end: this.$dayjs(new Date(this.form.end.year, this.form.end.month - 1, this.form.end.day))
                    .format('YYYY-MM-DD')
      };

      this.$emit('getPointAndMoney', data)
    },

    setStartDate(data) {
      this.form.start = data;
    },

    setEndDate(data) {
      this.form.end = data;
    }
  },
}
</script>
<style lang="scss" scoped>
  .form-search-date {
    .el-form-item__label {
      margin-top: 15px;
      display: inline-block;
    }
    .btn-search {
      height: 35px;
      span {
        line-height: normal;
      }
    }
    .range {
      line-height: unset !important;
      position: relative;
      span {
        position: absolute;
        bottom: 30px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }

</style>